import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BlockModel} from '../model/block.model';
import {QuestionInfo, QuestionModel} from '../model/question.model';
import {UserAnswerMode} from '../model/user-answer.mode';
import {CHAT_CONFIG} from "../config/api";

@Injectable({
  providedIn: 'root'
})
export class QuizService {
  token;

  constructor(private http: HttpClient) {
    if ((window as any).token) {
      this.token = (window as any).token;
    }

  }

  getQuestionSteps() {
      return this.http.post(CHAT_CONFIG.getQuestionSteps, {});
  }

  getQuestionBlock(blockId: number) {
    return this.http.get<BlockModel>(`api/quiz/${blockId}`);
  }

  getQuestion(blockId: number) {
    return this.http.get<QuestionInfo>(`api/quiz/${blockId}/first-question`);
  }

  getNextQuestion(blockId: number, previousQuestionId: number) {
    return this.http.get<QuestionInfo>(`api/quiz/${blockId}/questions/${previousQuestionId}/next-question`);
  }



  getPreviousQuestion(blockId: number, questionId: number) {
    return this.http.get<QuestionInfo>(`api/quiz/${blockId}/questions/${questionId}/previous`);
  }

  setAnswer(blockId: number, questionId: number, answer: UserAnswerMode) {
    return this.http.post(`api/quiz/${blockId}/questions/${questionId}`, answer);
  }

}
